module.exports = __webpack_public_path__ + "tinymce-small.svg?a2a1f732cc34764c684ed521c6f3327c";